// Utilidades compartidas para precios por cantidad (descuento por volumen).
// Usadas tanto por el contexto de React (QuantityPricingContext) como por el
// slice de Redux del carrito (cartSlice), por eso viven en un módulo plano
// sin dependencias de React ni de Redux.

// Extrae el id de categoría ya sea que venga como objeto poblado o como string/ObjectId.
export const getCategoryId = (categoryLike) => (
  categoryLike && typeof categoryLike === 'object' ? categoryLike._id : categoryLike
);

export const getPricingScopeKey = (categoryLike, subcategory = '') => (
  `${getCategoryId(categoryLike)?.toString() || ''}::${typeof subcategory === 'string' ? subcategory.trim() : ''}`
);

// Calcula el precio unitario efectivo dado un array de tiers [{minQuantity, price}],
// una cantidad y un precio base de fallback (cuando no hay tiers o ninguno aplica).
export const getEffectiveUnitPrice = (tiers, quantity, basePrice) => {
  const qty = Number(quantity) || 1;
  const fallback = Number(basePrice) || 0;

  if (!Array.isArray(tiers) || tiers.length === 0) return fallback;

  const applicable = tiers
    .filter(t => t.price !== null && t.price !== undefined && qty >= Number(t.minQuantity))
    .sort((a, b) => Number(b.minQuantity) - Number(a.minQuantity));

  return applicable.length > 0 ? Number(applicable[0].price) : fallback;
};
